import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { confirmUserAccount } from '../../services/user/api'; // adjust path if needed

const ConfirmAccount = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  useEffect(() => {

    if (token) {
      confirmUserAccount(token)
        .then((response) => {
          alert(response.data.message || 'Account confirmed successfully!');
          navigate('/');
        })
        // .catch((error) => {
        //   console.error('Confirmation error:', error.response?.data || error.message);
        //   alert(token);
        //   //navigate('/');
        // });
    } else {
      alert('No token found in URL');
     // navigate('/');
    }
  }, [token, navigate]);

  return <div>Confirming your account...</div>;
};

export default ConfirmAccount;
